import { Icon, type IconName } from '@/components/icons';

/** One icon per Likert row index (0–4). */
const OPTION_ICON_NAMES: IconName[] = [
  'heart-filled',
  'scales-balance-filled',
  'paw-print-filled',
  'warning-triangle-filled',
  'eye-off-filled',
];

export function MatchQuizOptionIcon({
  optionIndex,
  className,
}: {
  optionIndex: number;
  className?: string;
}) {
  const name =
    OPTION_ICON_NAMES[optionIndex % OPTION_ICON_NAMES.length] ?? 'dot';
  return <Icon name={name} className={className} />;
}
